import { render, staticRenderFns } from "./ToiawasePage.vue?vue&type=template&id=2533c2b9&scoped=true&"
import script from "./ToiawasePage.vue?vue&type=script&lang=ts&"
export * from "./ToiawasePage.vue?vue&type=script&lang=ts&"
import style0 from "./ToiawasePage.vue?vue&type=style&index=0&id=2533c2b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2533c2b9",
  null
  
)

export default component.exports